export enum UserRoles {
  User = 'user',
  Admin = 'admin'
}
